import { SignerRequest } from './signer-request';

export class PostDocumentRequest {
  public ApiKey?: string;
  public PackageName?: string;
  public Initiator?: string;
  public DocumentGroupCode?: string;
  public ExternalPackageReference?: string;
  public RedirectUrl?: string;
  public DocumentName?: string;
  public DocumentLanguage?: string;
  public DocumentContent?: string;
  public ExternalDocumentReference?: string;
  public Signers: SignerRequest[];
}
